// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next'

import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'

export const weekDaysSchema = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6)
])

export const dateInputBlockValueSchema = z.object({
  startDate: z.union([z.date(), z.string()]).optional().nullable(),
  endDate: z.union([z.date(), z.string()]).optional().nullable()
})

const fieldOptionDateSchema = z.any()

export const dateInputBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.DATE_INPUT),
  settings: blockBaseSettingsSchema.and(
    z.object({
      fields: z.object({
        startDate: fieldOptionDateSchema,
        endDate: fieldOptionDateSchema.optional()
      }),
      disableDays: z.array(weekDaysSchema).optional(),
      showTime: z.boolean().optional(),
      timeIntervals: z.number().optional()
    })
  )
})
